<div class="notification-drawer" data-cy="notificationDrawer">
    <div
        class="notification-drawer__header flex-col flex justify-between pt-4 px-4 border-gray-300 border-b w-full"
    >
        <div
            class="notification-drawer__header__title flex flex-row items-center w-full justify-between pb-2"
        >
            <div class="notification-drawer__header__title__title-gear flex flex-row">
                <span class="mat-subtitle-1">Notifications</span>
            </div>
            <div class="flex flex-row items-center">
                <notifications-header-menu
                    (markAllRead)="markAllRead()"
                    (clearAll)="deleteAll()"
                >
                </notifications-header-menu>
                <a
                    href="javascript:;"
                    (click)="toggleOpen()"
                    class="notification-drawer__header__close cursor-pointer block"
                >
                    <span class="flex items-center pl-2"><mat-icon class="h-3.5 w-3.5">close</mat-icon></span>
                </a>
            </div>
        </div>
        <div class="pt-2">
            <notifications-header-search
                [sorted]="isSorted"
                [sortDirection]="sortDirection"
                (sortChange)="handleSortDirection($event)"
                (quickFilterChange)="onQuickFilterChange($event)">
            </notifications-header-search>
        </div>
    </div>

    <div class="notification-drawer__content">
        <div [@fadeSlideInOut]>
            <ag-grid-angular class="ag-theme-quartz lender-notifications-grid"
                            [class.no-rows]="noRows()"
                            [rowData]="notifications"
                            [gridOptions]="notificationsGridOptions"
                            [initialState]="notificationsGridInitialState"
                            (firstDataRendered)="onFirstDataRendered($event)"
                            (filterChanged)="onFilterChanged($event)"
                            (gridReady)="onGridReady($event)"
                            (rowClicked)="onRowClicked($event)"
                            (rowDataUpdated)="onRowDataUpdated($event)">
            </ag-grid-angular>
        </div>
    </div>
</div>
